export default {
    title: 'Search',
    filter: 'Filter',
    hideFilter: 'Hide Filter',
    currentlyOnline: 'Currently online',
    noSearchResults: 'Your search had no results',
    clear: 'Clear filters'
}
